import { render, staticRenderFns } from "./pubTel.vue?vue&type=template&id=2ee82ca4&scoped=true&"
import script from "./pubTel.vue?vue&type=script&lang=js&"
export * from "./pubTel.vue?vue&type=script&lang=js&"
import style0 from "./pubTel.vue?vue&type=style&index=0&id=2ee82ca4&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee82ca4",
  null
  
)

export default component.exports